(function () {
  const scriptTag = document.currentScript;
  const sectionId = scriptTag.dataset.sectionId;
  const section = document.querySelector(`[data-section-id="${sectionId}"]`);
  if (!section) {
    return;
  }

  const titleElement = section.querySelector('.activities-collection__title');
  const descElement = section.querySelector('.activities-collection__decription');

  const activityCache = new Map();

  section.querySelectorAll('template.activities-collection__template').forEach(function (tpl) {
    activityCache.set(tpl.dataset.activityHandle, {
      tagline: tpl.content.querySelector('[data-tagline]'),
      description: tpl.content.querySelector('[data-description]'),
    });
  });

  const items = section.querySelectorAll('.product-card');
  const buttons = section.querySelectorAll('.activities-collection__activity');

  function applyFilter(handle, pushState) {
    const activity = activityCache.get(handle);
    if (!activity) {
      return;
    }

    if (activity.tagline) {
      titleElement.innerHTML = activity.tagline.innerHTML.trim();
    }
    if (activity.description) {
      descElement.innerHTML = activity.description.innerHTML.trim();
    }

    items.forEach(function (item) {
      const activities = item.dataset.activities ? item.dataset.activities.split('|') : [];
      item.hidden = handle !== 'all' && !activities.includes(handle);
    });

    buttons.forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.activityHandle === handle);
    });

    if (pushState) {
      const url = new URL(window.location.href);
      if (handle === 'all') {
        url.searchParams.delete('activity');
      } else {
        url.searchParams.set('activity', handle);
      }
      window.history.pushState({}, '', url);
    }
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyFilter(btn.dataset.activityHandle, true);
    });
  });

  const initialHandle = new URL(window.location.href).searchParams.get('activity') || 'all';
  applyFilter(initialHandle, false);
})();
